import styled from 'styled-components'

export const Container = styled.div`
  height: 13em !important;
  width: 100% !important;
  zoom: 125% !important;
  padding-bottom: 10px;
  overflow-y: hidden;
  overflow-x: auto;
`

export const ConteudoGrafico = styled.div`
  width: ${({ width }) => width};
  height: 100%;
  overflow: hidden;
`

export const TooltipWrapper = styled.div`
  min-width: 200px;
  padding: 0.625em 0.625em 0.625em 0.625em !important;
  border-radius: 0.3125em !important;
  background-color: ${({ theme }) => theme.cor53}!important;
  border: 1px solid ${({ theme }) => theme.cor59};
`

export const TooltipContent = styled.div`
  display: grid;
  gap: 4px;
`

export const TituloTooltip = styled.h1`
  font-weight: 600;
  font-size: 14px;
`

export const LinhasWrapper = styled.div`
  font-size: 14px;
  display: flex;
  justify-content: space-between;
`

export const Elipse = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.cor11}!important;
`

export const LinhasContent = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

export const SemDados = styled.div`
  background-color: #0000000a;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
`

export const BlankSlateContainer = styled.div`
  padding-top: 30px;
  height: 305px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`